import React from "react";
import {
  AwInputFormField,
  AwPrimeReactCalendar,
  AwFormFieldWrapper
} from "../../../../../components";
import { convertStringToDate } from "../../../../../utils";

export const PharmacistCreateForm = ({ dObj, fieldChange }) => {
  return (
    <form noValidate>
      {formFields.map((field, i) => {
        return field.isDate ? (
          getDateField(dObj, field, fieldChange, i)
        ) : (
          <AwInputFormField
            key={i}
            required={true}
            init={Object.keys(dObj).length > 0 ? dObj[field.name] : ""}
            name={field.name}
            label={field.label}
            onChange={fieldChange}
          />
        );
      })}
    </form>
  );
};

export default PharmacistCreateForm;
const getDateField = (dObj, field, change, i) => {
  let date = new Date();
  if (dObj[field.name]) date = convertStringToDate(dObj[field.name]);
  return (
    <AwFormFieldWrapper
      required={true}
      name={field.name}
      label={field.label}
      key={i}
    >
      <div style={{ marginRight: "30px" }}>
        <AwPrimeReactCalendar
          type={field.name}
          dateSelected={change}
          init={date}
        />
      </div>
    </AwFormFieldWrapper>
  );
};
const formFields = [
  { name: "LicenseNumber", label: "License" },
  { name: "FirstName", label: "First Name" },
  { name: "LastName", label: "Last Name" },
  { name: "EffectiveDate", label: "Effective Date", isDate: true },
  { name: "ExpDate", label: "Expiration Date", isDate: true },
  { name: "PIC", label: "PIC" }
];
